import React from 'react'

function index(props) {
  return <div>Painel comercial</div>
}

export default index
